import { render, staticRenderFns } from "./country-name.vue?vue&type=template&id=3c9e4699&"
import script from "./country-name.vue?vue&type=script&lang=ts&"
export * from "./country-name.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports